<template>
  <div>
    <div v-if="!showAddRole && !showAssignRolePermissions && hasPermission('Add Role')" class="btn-group-hdr">
        <div class="btn-group btn-group-toggle">
            <!--<router-link :to="create" class="btn btn-primary btn-sm">Add Role</router-link>-->
            <button class="btn btn-primary btn-sm" @click="showAddRole = true">Add Role</button>
        </div>
    </div>

    <add-edit-role
          v-if="showAddRole"
          :role="editingRole"
          @cancel="cancelEdit"
          @role-added="onRoleAdded"
          @role-updated="onRoleUpdated"
        ></add-edit-role>

    <manage-users
      v-if="showManageUsers"
      :role="selectedRole"
      :initial-left="manageUsersState.left"
      :initial-right="manageUsersState.right"
      :loading="manageUsersState.loading"
      :saving="manageUsersState.saving"
      :error-text="manageUsersState.error"
      @close="closeManageUsers"
      @save="saveRoleUsers"
    />

    <assign-role-permissions
      v-if="showAssignRolePermissions"
      :role="roleForPermissions"
      :permissions="rolePermissions"
      @cancel="cancelAssignRolePermissions"
      @save="saveAssignedRolePermissions"
      :has-permission="hasPermission"
    />


    <div v-if="!showAddRole && !showAssignRolePermissions && !showManageUsers">
      <div class="title-hdr bg-dark">
          {{title}}
      </div>

      <!-- <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
      </div> -->

      <div class="card">
          <div class="card-body">
            <data-viewer :source="source" :thead="thead" :key="rolesViewerKey">
              <template slot-scope="props">
                  <tr>
                      <td>{{props.item.role_name}}</td>
                      <td>{{props.item.description}}</td>
                      <td>
                        <button v-if="hasPermission('Edit Role')" class="btn btn-primary btn-sm" data-bs-toggle="tooltip" title="Edit Role" @click="editRole(props.item)">
                          <i class="fas fa-pen fa-sm"></i>
                        </button>
                        <button v-if="hasPermission('Assign User Management Permissions')||hasPermission('Assign DRP Permissions')||hasPermission('Assign Store Permissions')" class="btn btn-secondary btn-sm" data-bs-toggle="tooltip" title="Assign Permission" @click="assignRolePermissions(props.item)">
                          <i class="fas fa-key fa-sm"></i> <!-- key icon for permissions -->
                        </button>

                        <button
                          v-if="hasPermission('Assign User Roles')"
                          class="btn btn-info btn-sm ms-1"
                          data-bs-toggle="tooltip"
                          title="Manage Users"
                          @click="openManageUsers(props.item)"
                        >
                          <i class="fas fa-users fa-sm"></i>
                        </button>


                        <button v-if="hasPermission('Delete Role')"
                                class="btn btn-danger btn-sm ms-1"
                                data-bs-toggle="tooltip"
                                title="Delete Role"
                                @click="deleteRole(props.item)">
                          <i class="fas fa-trash fa-sm"></i>
                        </button>

                      </td>
                  </tr>
              </template>
            </data-viewer>
          </div>
      </div>
    </div>

  </div>

</template>

<script>
  import axios from 'axios'
  import { baseUrl } from '../../../.env.js'
  import { bus } from '../../../main.js'

  import DataViewer from './../common/DataViewer.vue'
  import AddEditRole from './AddEditRole.vue'
  import AssignRolePermissions from './AssignRolePermissions.vue'  // import here
  import ManageUsers from './ManageUsers.vue'


  export default {
    name: 'RoleData',
    props: {
      hasPermission: {
        type: Function,
        required: true
      }
    },
    components: {
        DataViewer,
        AddEditRole,
        AssignRolePermissions,
      ManageUsers
    },
    data() {
      return {
        certs: {},
        baseUrl : baseUrl,
        title: 'Roles',
        source: '/user/roles',
        showAddRole: false,
        showAssignRolePermissions: false,  // new state
        roleForPermissions: null,      // selected role for permission assignment
        rolePermissions: [],
        editingRole: null,
        rolesViewerKey: 0,
        showManageUsers: false,
        selectedRole: null,
        manageUsersState: {
          loading: false,
          saving: false,
          error: '',
          left: [],   // assigned users
          right: [],  // available users
        },
      }
    },
    mounted() {
      var vm = this;
      this.$store.commit('selectedTab', 'roles');
      this.fetchRoles()

      // Initialize Bootstrap tooltips
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        new bootstrap.Tooltip(tooltipTriggerEl)
      })

      bus.$on('nav:roles-root', this.goToRolesRoot);
    },
    beforeDestroy() {
      bus.$off('nav:roles-root', this.goToRolesRoot);
    },
    methods: {
      refreshRoles() {
        // 1) If DataViewer provides reload(), use it
        if (this.$refs.rolesViewer && this.$refs.rolesViewer.reload) {
          this.$refs.rolesViewer.reload()
        }
        // 2) Also bump the key to force a re-render and bypass any internal cache
        this.rolesViewerKey += 1

        // 3) Re-init tooltips after DOM updates
        this.$nextTick(() => {
          var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          tooltipTriggerList.forEach(function (tooltipTriggerEl) {
            new bootstrap.Tooltip(tooltipTriggerEl)
          })
        })
      },
      goToRolesRoot() {
        // Close all sub-views/pages under Roles
        this.showAddRole = false;
        this.editingRole = null;

        this.showAssignRolePermissions = false;
        this.roleForPermissions = null;

        // Optional: refresh the roles table if needed
        if (this.$refs.rolesViewer && this.$refs.rolesViewer.reload) {
          this.$refs.rolesViewer.reload();
        }
      },
      addRole() {
        this.editingRole = null
        this.showAddRole = true
      },
      editRole(role) {
        this.editingRole = Object.assign({}, role)  // clone to avoid direct mutation
        this.showAddRole = true
      },
      cancelEdit() {
        this.editingRole = null
        this.showAddRole = false
      },
      onRoleAdded() {
        this.showAddRole = false
        this.fetchRoles()  // refresh roles list after adding
      },
      onRoleUpdated() {
        this.showAddRole = false
        this.editingRole = null
        this.fetchRoles()  // refresh roles list after updating
      },
      fetchRoles() {
        // Fetch roles from API and update this.roles
        // Example:
        // this.$axios.get('/api/v1/user/sys/roles').then(res => {
        //   this.roles = res.data.model.data
        // })
      },
      // New method to open assign permission UI
      assignRolePermissions(role) {
        const url = `/user/roles/${role.role_id}/permissions`
        console.log('Get permission by Role id', url)
        axios.get(url)
          .then((response) => {
            if (response.data) {
              this.rolePermissions = response.data.permissions;
            } else {
              this.rolePermissions = [];
            }
          })
          .catch((error) => {
            this.rolePermissions = [];
          })

        this.roleForPermissions = Object.assign({}, role)
        this.showAssignRolePermissions = true
      },
      // Handle cancel from AssignRolePermissions component
      cancelAssignRolePermissions() {
        this.roleForPermissions = null
        this.showAssignRolePermissions = false
      },
      saveAssignedRolePermissions({ roleId, permissions }) {
        if (!roleId) {
          console.error('roleId is undefined!');
          return;
        }
        const url = `/user/roles/${roleId}/permissions`
        var vm = this
        axios.post(url, { permissions })
          .then(response => {
            // Extract success message from response if available
            const message = (response.data && response.data.message) || 'Role permissions saved successfully!'

            Swal.fire({
              type: 'success',
              title: 'Success',
              text: message
            }).then(() => {
              this.showAssignRolePermissions = false
              this.roleForPermissions = null
              // this.fetchRoles()
            })
          })
          .catch(err => {
            // Extract error message safely
            let message = 'Failed to save permissions'
            if (err && err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                message = err.response.data
              } else if (err.response.data.error) {
                message = err.response.data.error
              } else if (err.response.data.message) {
                message = err.response.data.message
              }
            }

            Swal.fire({
              type: 'error',
              title: 'Error',
              text: message
            })
            console.error(err)
          })
      },
      async openManageUsers(role) {
        this.selectedRole = role;
        this.showManageUsers = true;

        this.manageUsersState.loading = true;
        this.manageUsersState.saving = false;
        this.manageUsersState.error = '';
        this.manageUsersState.left = [];
        this.manageUsersState.right = [];

        try {
          const url = `/user/roles/${role.role_id}/manage/users`;
          const resp = await axios.get(url);
          const data = resp && resp.data ? resp.data : null;

          // Adapt to your API shape:
          const model = data && data.model ? data.model : data;

          const left = (model && model.role_users) ? model.role_users : [];
          const right = (model && model.role_manage_users) ? model.role_manage_users : [];

          // Ensure right excludes left (safety)
          const leftIds = {};
          for (var i = 0; i < left.length; i++) leftIds[left[i].user_id] = true;

          const rightFiltered = [];
          for (var j = 0; j < right.length; j++) {
            var u = right[j];
            if (!leftIds[u.user_id]) rightFiltered.push(u);
          }

          this.manageUsersState.left = left;
          this.manageUsersState.right = rightFiltered;
        } catch (err) {
          console.error(err);
          this.manageUsersState.error = 'Failed to load users for this role. Please try again.';
          this.manageUsersState.left = [];
          this.manageUsersState.right = [];
        } finally {
          this.manageUsersState.loading = false;
        }
      },

      closeManageUsers() {
        this.showManageUsers = false;
        this.selectedRole = null;
        this.manageUsersState = {
          loading: false,
          saving: false,
          error: '',
          left: [],
          right: [],
        };
      },

      async saveRoleUsers(roleId, userIds) {
        this.manageUsersState.saving = true;
        try {
          const url = `/user/roles/${roleId}/manage/users`;
          await axios.put(url, { data: userIds });

          Swal && Swal.fire && Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Role users saved successfully!'
          });

          // Back to Roles list
          this.closeManageUsers();

          // Optional refresh roles table
          this.refreshRoles && this.refreshRoles();
        } catch (err) {
          console.error(err);
          this.manageUsersState.saving = false;

          let message = 'Failed to save role users.';
          if (err && err.response && err.response.data) {
            if (typeof err.response.data === 'string') message = err.response.data;
            else if (err.response.data.error) message = err.response.data.error;
            else if (err.response.data.message) message = err.response.data.message;
          }

          Swal && Swal.fire && Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message
          });
        }
      },
      deleteRole(role) {
        const roleName = role && role.role_name ? role.role_name : 'this role'
        Swal.fire({
          title: 'Delete Role',
          text: 'Do you want to delete this Role?',
          type: 'warning',           // (if you use Swal v11+, this is `icon: 'warning'`)
          showCancelButton: true,
          confirmButtonText: 'Yes, delete',
          cancelButtonText: 'Cancel'
        }).then(async (result) => {
          if (result && result.value) {
            try {
              // Call your DELETE endpoint (adjust path if different)
              const url = `/user/roles/${role.role_id}`
              const response = await axios.delete(url)

              // Show success message from API if provided
              const message = (response && response.data && response.data.message)
                  ? response.data.message
                  : ('Role "' + roleName + '" has been deleted.')

              await Swal.fire({
                type: 'success',
                title: 'Deleted',
                text: message
              })

              // Refresh the list
              if (this.$refs.rolesViewer && this.$refs.rolesViewer.reload) {
                this.$refs.rolesViewer.reload()
              } else {
                this.refreshRoles()
              }
            } catch (err) {
              // Extract error from API response (string or object)
              let message = 'Failed to delete role.'
              if (err && err.response && err.response.data) {
                if (typeof err.response.data === 'string') {
                  message = err.response.data
                } else if (err.response.data.error) {
                  message = err.response.data.error
                } else if (err.response.data.msg) {
                  message = err.response.data.msg
                }
              }
              Swal.fire({
                type: 'error',
                title: 'Error',
                text: message
              })
            }
          }
        })
      },
    },
    computed: {
        thead: function () {
            return [
                {title: 'Role Name', key: 'role_name', sort: true},
                {title: 'Description', key: 'description', sort: true}
            ]
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/users/RoleData.vue